import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import styled from "styled-components";


// import n_img from "../partners/tools/science_cover.jpg";
import n_img from "../partners/tools/soyuz.jpg";
import ScienceSelectTool from "../partners/tools/ScinceSelectTool";
import AmbassadorViewTool from "../ambassadors/tools/AmbassadorViewTool";
import AdminAmbassadorsPanel from "../ambassadors/panels/AdminAmbassadorsPanel";

const AdminAmbassadorsPage = () => {
    const { t } = useTranslation();

    const [bigUrl, setBigUrl] = useState(undefined);

    return (
        <OuterWrapper className={"ambassadors"}>


            <Wrapper>

                <AdminAmbassadorsPanel

                />

            </Wrapper>

        </OuterWrapper>
    );
};

const TopTextPlaceholder = styled.div`
  width: 1360px;
  box-sizing: border-box;
  //padding: 15px;
  font-family: "Noto Sans", sans-serif;
  line-height: 32px;
  font-size: 24px;
  text-align: center;

  margin: 0 auto;
  text-align: justify;
  
  margin-bottom: 50px;
  margin-top: 50px;
  
  
  @media (max-width: 1360px) {
    width: 100%;
  }
`;


const OuterWrapper = styled.div`
  width: 100%;
  background: white;
  padding-top: 30px;
  box-sizing: border-box;
  padding-bottom: 40px;
`;

const Wrapper = styled.div`
  text-align: left;

  font-family: "Noto Sans", sans-serif;
  
  box-sizing: border-box;
  width: 1400px;
  margin: 0 auto;
  padding: 15px;
  @media (max-width: 1400px) {
    width: 100%;
  }
`;

const Heading = styled.div`
  font-family: "Noto Sans", sans-serif;
  text-align: center;
  font-style: normal;
  font-weight: 700;
  font-size: 56px;
  line-height: 72px;
  margin-bottom: 40px;
  @media (max-width: 820px) {
    font-size: 24px;
    line-height: 32px;
    padding-left: 5px;
  }
`;

const SupTopPlaceholder = styled.div`
  margin-bottom: 20px;
`;

const TopPlaceholder = styled.div``;

export default AdminAmbassadorsPage;
